import { useEffect, useRef } from "react";

const isTypingTarget = (el) =>
  el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT" || el.isContentEditable);

// Keyboard-wedge scanner: fast keystrokes ending in Enter, captured globally when no field is focused.
export function useBarcodeScanner(onScan, { maxGap = 60, minLength = 3 } = {}) {
  const buf = useRef("");
  const last = useRef(0);
  const cb = useRef(onScan);
  cb.current = onScan;

  useEffect(() => {
    const onKey = (e) => {
      if (isTypingTarget(e.target) || document.querySelector('[role="dialog"]')) return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      const now = performance.now();
      if (now - last.current > maxGap) buf.current = "";
      last.current = now;
      if (e.key === "Enter") {
        const code = buf.current;
        buf.current = "";
        if (code.length >= minLength) {
          e.preventDefault();
          cb.current(code);
        }
        return;
      }
      if (e.key.length === 1) buf.current += e.key;
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [maxGap, minLength]);
}
